module.exports = __webpack_public_path__ + "img/Avatar-22.2089799d.gif";